import { render, staticRenderFns } from "./index6.vue?vue&type=template&id=04611010&scoped=true&"
import script from "./index6.vue?vue&type=script&lang=js&"
export * from "./index6.vue?vue&type=script&lang=js&"
import style0 from "./index6.vue?vue&type=style&index=0&id=04611010&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04611010",
  null
  
)

export default component.exports